import React from 'react'
import formattedMessage from './languageModule'
import PropTypes from 'prop-types'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantTable from '@nexidigital/merchanttable'
import { formatCurrency, nullSafe, formatThousands } from 'Utility/globalMethods'
import { findCircuitPaymentMethod } from 'Utility/circuits'
import './PaymentsDetail.scss'

const formatPercentage = (value) => {
  if (value === 0) return '0'
  const formatted = value.toFixed(2)
  return formatThousands(parseFloat(formatted))
}

const FirstPeriodDetail = ({ totals, transactions, referredPeriod }) => {
  const rows = (Array.isArray(transactions) ? transactions : []).map(item => {
    const transactionPercent = nullSafe(() => item.transactionPercent, 0)
    const { img, label } = findCircuitPaymentMethod(item.cardBrand)

    return transactionPercent !== 0 && {
      paymentMethod: (
        <div className='tablePaymentMethod'>
          {img && <img className='tablePaymentImg' src={img} alt={label} />}
          {label}
        </div>
      ),
      transaction: <b>{formatPercentage(item.transactionPercent)}%</b>,
      transacted: <b>{formatCurrency(item.transactionCost)}</b>
    }
  })

  return (
    <div className='paymentsDetailPeriodDetail'>
      <div className='paymentsDetailPeriodDates'>
        <p className=''>{formattedMessage.period}</p>
        <MerchantTableBadge label={referredPeriod[0]} status='neutralLight' /> -
        <MerchantTableBadge label={referredPeriod[1]} status='neutralLight' />
      </div>
      <div className='paymentsDetailPeriodContent'>
        <MerchantGenericCard title={formattedMessage.title}>
          <div className='keyIndicatorPeriod'>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.paymentsMethods}</div>
              <div className='keyIndicatorValue'>{totals.brandsCount}</div>
            </div>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.transactions}</div>
              <div className='keyIndicatorValue'>{formatThousands(totals.transactionsCount)}</div>
            </div>
            <div className='keyIndicatorRow'>
              <div className='keyIndicatorLabel'>{formattedMessage.transacted}</div>
              <div className='keyIndicatorValue'>{formatCurrency(totals.transactionsCost)}</div>
            </div>
          </div>

          <div className='tablePaymentDetail'>
            <MerchantTable
              name='merchantPortal'
              tabIndex={-1}
              columns={[{
                id: 'paymentMethod',
                label: formattedMessage.payment,
                sx: { width: '33.33%' }
              }, {
                id: 'transaction',
                label: formattedMessage.transactions,
                align: 'right',
                sx: { width: '33.33%' }
              }, {
                id: 'transacted',
                label: formattedMessage.transacted,
                align: 'right',
                sx: { Width: '33.33%' }
              }]}
              onPagination={() => { }}
              onSort={() => { }}
              rows={rows}
              sx={{ border: '0' }}
            />
          </div>
        </MerchantGenericCard>
      </div>
    </div>
  )
}

FirstPeriodDetail.propTypes = {
  totals: PropTypes.object,
  transactions: PropTypes.object,
  referredPeriod: PropTypes.array
}

FirstPeriodDetail.defaultProps = {
  totals: {},
  transactions: {},
  referredPeriod: ['-', '-']
}

export default FirstPeriodDetail
